import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import ProfilePhoto from '../atoms/profile/ProfilePhoto';
import { auth10tixVerification } from '../config/Master';
import ProfilePhotoSliderV2 from '../atoms/profile/ProfilePhotoSliderV2';
import OtherProfileCoverInfo from './OtherProfileCoverInfo';
import { useProfile } from '../contexts/ProfileContext';
import { areEqual } from '../utils/helpers';
import { RootState } from '../store';
import { useSelector } from 'react-redux';
import breakpoints from '../theme/material/breakpoints';

const Cover = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',

  [breakpoints.down(944.05)]: {
    maxWidth: '100%',
  },

  [breakpoints.down(620.05)]: {
    flexDirection: 'column',
    alignItems: 'stretch',
    padding: '0px',
    maxWidth: '100%',
  },
});

const InfoContainer = styled('div')({
  paddingLeft: '12px',
  flex: 3,
  zIndex: 3,
  maxWidth: '494px',
  display: 'flex',
  flexDirection: 'column',
  height: 'auto',
  justifyContent: 'space-between',
  gap: 29,
  [breakpoints.down('sm')]: {
    maxWidth: '100%',
  },

  [breakpoints.down(944.05)]: {
    maxWidth: '100%',
  },
  [breakpoints.down(620.05)]: {
    paddingLeft: '0px',
    margin: '0 15px',
    position: 'relative',
    maxWidth: '100%',
    height: '100%',
  },
});

const PhotoWrapperDesktop = styled('div')({
  display: 'block',
  [breakpoints.down(620.05)]: {
    display: 'none',
  },
});

const PhotoWrapperMobile = styled('div')({
  display: 'none',
  [breakpoints.down(620.05)]: {
    display: 'block',
  },
});

const ProfileInfoDesktop = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  padding: 0,

  [breakpoints.down(620.05)]: {
    display: 'none',
  },
});

const ProfileInfoMobile = styled('div')({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  position: 'absolute',
  bottom: 50,
  zIndex: 3,
  width: '100%',
});

const PhotoContainer = styled('div')({
  flex: 1,
  maxWidth: '245px',
  minWidth: '245px',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',

  [breakpoints.down(620.05)]: {
    maxWidth: '100%',
    height: 'auto',
  },
});

const CoverContent = styled('div')({
  margin: '0',

  [breakpoints.down(620.05)]: {
    margin: '15px 0 0px',
  },
});

const OtherProfileCover = (props: any): ReactElement => {
  const {
    username,
    age,
    location,
    lastLoginTime,
    lastLoginLocation,
    profileImg,
    favorited,
    onClickFavorite,
    onClickPhoto,
    myPhotos,
    otherProfilePhotos,
    isOtherProfile,
    isVerified = false,
    offer,
    myProfile,
    isSelfieVerified,
  } = props;

  const photoList = isOtherProfile ? otherProfilePhotos : (myPhotos && myPhotos.data) || [];
  const { profileDetailsRef } = useProfile();
  const isBlocked = useSelector((state: RootState) => state.extprofile?.is_blocked);

  const renderProfileInfo = () => {
    return (
      <OtherProfileCoverInfo
        age={age}
        isVerified={isVerified}
        username={username}
        favorited={favorited}
        lastLoginTime={lastLoginTime}
        onClickFavorite={onClickFavorite}
        auth10tixVerification={auth10tixVerification}
        location={location}
        lastLoginLocation={lastLoginLocation}
        shouldShowFavoriteButton={!isBlocked}
        isSelfieVerified={isSelfieVerified}
      />
    );
  };

  return (
    <Cover className="profile-cover">
      <PhotoWrapperDesktop>
        <PhotoContainer>
          <ProfilePhoto
            imgUrl={profileImg}
            onClick={onClickPhoto}
            offer={offer}
            myProfile={myProfile}
            isOtherProfile={true}
          />
        </PhotoContainer>
      </PhotoWrapperDesktop>
      <PhotoWrapperMobile>
        <ProfilePhotoSliderV2
          photoList={photoList}
          onClick={onClickPhoto}
          offer={offer}
          isOtherProfile={isOtherProfile}
          profileDetailsComponent={<ProfileInfoMobile ref={profileDetailsRef}>{renderProfileInfo()}</ProfileInfoMobile>}
        />
      </PhotoWrapperMobile>
      <InfoContainer className="profile-cover__info">
        <ProfileInfoDesktop>{renderProfileInfo()}</ProfileInfoDesktop>
        <CoverContent>{props.children}</CoverContent>
      </InfoContainer>
    </Cover>
  );
};

export default React.memo(OtherProfileCover, areEqual);
